import { render, staticRenderFns } from "./BinStorage.vue?vue&type=template&id=439d404b&scoped=true&"
import script from "./BinStorage.vue?vue&type=script&lang=js&"
export * from "./BinStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439d404b",
  null
  
)

export default component.exports